import React from "react";
import PropTypes from "prop-types";
import { Image, Button } from "@learningblocks/shared-components";
import SuccessIcon from "@common/images/success.svg";
import style from "./style.module.scss";

export function NextSlideBanner(props) {
  const goToNextSection = (event) => {
    event.preventDefault();
    event.stopPropagation();
    props.toNextSlide(props.nextSlideType);
  };

  if (props.complete) {
    return (
      <div className={style.nextSlideBanner}>
        <div>
          <Image src={SuccessIcon} alt="slide_successful" />
          <p>{props.successNote}</p>
        </div>
        <Button onClick={goToNextSection}>Next</Button>
      </div>
    );
  } else return null;
}

NextSlideBanner.propTypes = {
  /**
   * Boolean to specify if current DesignSlide in view is complete
   */
  complete: PropTypes.bool.isRequired,
  /**
   * Type value for the next slide type
   */
  nextSlideType: PropTypes.string.isRequired,
  /**
   * Function to invoke when next slide button is pressed
   */
  toNextSlide: PropTypes.func.isRequired,
  /**
   * Message to display on the banner
   */
  successNote: PropTypes.string.isRequired,
};

NextSlideBanner.defaultProps = {
  complete: false,
  nestSlideType: "",
  successNote: "",
};
